import React from 'react';
import {NavLink} from 'react-router-dom';

// css style for (check icon. exclamation icon, app-container)
import './Signup.css';

const SignUp = ({submitHandler, changeHandler, errors, isSubmitted}) => {

    return (
        <div className='app-container'>
            <div className='title-container'>
                <h3>Sign UP</h3>
            </div>
             <form className='form-container' onSubmit={submitHandler}>
                <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="input"  placeholder= 'Enter name'
                 name='name'id="name" onChange={changeHandler}/>
                 {/* after user click sign up button if there is any error will be shown else a check icon will show (same for all input fields) */}
                {isSubmitted ? (errors.nameErr ? 
                    <div className='error-caption'>
                        <small>
                            {errors.nameErr}<i className='fa fa-exclamation-circle'></i>
                        </small> 
                    </div> : <i className='fa fa-check-circle'></i>): ''}
                {/*---------------------------------------------------  */}
                </div>
                <div className="form-group">
                <label htmlFor="email">Email address:</label>
                <input type="input"  placeholder="Enter email"
                 name='email' id="email" onChange={changeHandler} />
                 {isSubmitted ? (errors.emailErr ? 
                    <div className='error-caption'>
                        <small>
                            {errors.emailErr}<i className='fa fa-exclamation-circle'></i>
                        </small>
                    </div> : <i className='fa fa-check-circle'></i>): ''}
                </div>
                <div className="form-group">
                <label htmlFor="password1">Password:</label>
                <input type="password" className="" placeholder="Enter password" 
                name='password1' id="password1" onChange={changeHandler} />
                {isSubmitted ? (errors.password1Err ? 
                    <div className='error-caption'>
                        <small>
                            {errors.password1Err}<i className='fa fa-exclamation-circle'></i>
                        </small>   
                    </div> : <i className='fa fa-check-circle'></i>): ''}
                </div>
                <div className="form-group">
                <label htmlFor="password2">confirm-Password:</label>
                <input type="password" placeholder="Confirm password"
                 name='password2' id="password2" onChange={changeHandler} />
                 {isSubmitted ? ((errors.password2Err || errors.password1Err)? 
                    <div className='error-caption'>
                        <small>
                            {errors.password2Err}<i className='fa fa-exclamation-circle'></i>
                        </small>
                    </div> : <i className='fa fa-check-circle'></i>): ''}
                </div>
                <div className='button-container'>
                    <button type="submit">Sign Up</button>
                </div>
                <div className='account-title'>
                    <h6>
                        Alredy have an account? 
                 <NavLink to='/signin' style={{fontSize:'14px'}}>{' '}Sign in</NavLink>
                    </h6>
                </div>
            </form>  
        </div>
    )
}

export default SignUp;
